import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { refetchApiInterval } from "../../shared/constants";
import { createChargerAssetLink, getChargerAssetLinks } from "../api/eflow-charger-asset-links.service";
export const useCreateChargerAssetLink = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (requestBody) => {
            return await createChargerAssetLink(requestBody);
        },
        onSuccess: () => {
            // Invalidate charger asset links queries to refetch the updated list
            queryClient.invalidateQueries({ queryKey: ["chargerAssetLinks"] });
        }
    });
};
export const useChargerAssetLinks = (requestBody, cursor, limit, skip, orderBy, sortBy, enabled = true, refetchApiData) => {
    return useQuery({
        enabled,
        gcTime: 5 * 60 * 1000, // Keep cache for 5 minutes
        queryFn: async () => {
            return await getChargerAssetLinks(requestBody, cursor, limit, skip, orderBy, sortBy);
        },
        queryKey: ["chargerAssetLinks", requestBody, cursor, limit, skip, orderBy, sortBy, refetchApiData],
        refetchInterval: refetchApiInterval, // Auto-refresh every 5 minutes
        refetchOnWindowFocus: false,
        retry: 1,
        staleTime: 0 // Always fetch fresh data when pagination parameters change
    });
};
